import AppError from 'errors/app-error'

export default class NotFoundError extends AppError {
  constructor(thing = 'Page') {
    super()
    this.statusCode = 404
    this.message = `${thing} Not Found`
  }
}
